import BaseDB from 'libs/DB/BaseDB'

const dataDB = new BaseDB('aiDataDB', {
  version: 1,
  key: 'id',
  expireDuration: 30 * 24 * 60 * 60 * 1000, // 만료 기간 30일.
  skipPreload: true,
})

export default dataDB
